/**
 * `SearchSource` over the C5 api. Structurally typed so this module never imports server code
 * (the same trick `modules/notifications/trpc-source.ts` uses).
 */
import type { SearchQueryInput, SearchResultsView, SearchSource } from './types';

interface Query<TIn, TOut> {
  query(input: TIn): Promise<TOut>;
}
interface Mutate<TIn, TOut> {
  mutate(input: TIn): Promise<TOut>;
}

export interface SearchTrpc {
  search: {
    query: Query<SearchQueryInput, SearchResultsView>;
    recent: Query<undefined, string[]>;
    remember: Mutate<{ term: string }, unknown>;
    clearRecent: Mutate<undefined, unknown>;
  };
}

export function createSearchSource(trpc: SearchTrpc): SearchSource {
  return {
    query: (input) => trpc.search.query.query(input),
    recent: () => trpc.search.recent.query(undefined),
    remember: async (term) => {
      await trpc.search.remember.mutate({ term });
    },
    clearRecent: async () => {
      await trpc.search.clearRecent.mutate(undefined);
    },
  };
}
